export default __webpack_public_path__ + "static/media/compartilharListaParceiros.5519dde0.svg";